import Basemap from "@arcgis/core/Basemap";
import TileLayer from "@arcgis/core/layers/TileLayer";
import Button from "@mui/material/Button";
import { useCallback, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import './BaseMapButton.scss';
import { baseMapList } from "src/constants";
import { useStoreContext } from "src/store/context";
import { useBaseMapSelection } from "src/store/actions";
import { useHistory } from "react-router";
import { buildPath } from "src/store/common";
export const mapUSGSImaegryBaseLayer = new TileLayer({
    url: baseMapList[1].url
});
export const imageryUSGSBasemap = new Basemap({
    baseLayers: [mapUSGSImaegryBaseLayer],
    title: "USGSImagery",
    id: "USGSImagery"
});
interface BaseMapProps {
    view: any;
    map: any;
}

 const BaseMapToggleButton :React.FC<BaseMapProps>= ({view, map})=>{
    const mapView:any = useRef(null);
    const [buttonLabel, setButtonLabel] = useState<string>(map.basemap?.id ==='topo'?'USGS Imagery':'World Topo')
    
    const [state, dispatch] = useStoreContext();
    const setBaseMap = useBaseMapSelection(dispatch);
    const history = useHistory();

    const toggleBaseMap = useCallback (()=>{

        const currentBasemap = map.basemap?.id;

        if(currentBasemap === 'topo'){
            setButtonLabel('World Topo');
            map.basemap = imageryUSGSBasemap;   
            setBaseMap(imageryUSGSBasemap);

            if(state.mapDataType==='Weather' || state.mapDataType==='FireDanger'){
                const paramsForBuildPath = {
                    dataType: state.mapDataType,
                    radio: state.selectedRadio.type,
                    element: state.selectedElement?.value,
                    zoom: state.currentZoom,
                    basemap: 'USGSImagery',
                    minElevation: state.elevationFilterValues[0],
                    maxElevation: state.elevationFilterValues[1],
                    windOrMethod: state.mapDataType==='FireDanger'? state.nfdrFuelModel : state.wind_direction,
                    windOrSub: state.mapDataType==='FireDanger'? false : state.wind_speed
                }
                buildPath(paramsForBuildPath, history);
            }
            if(state.mapDataType ==='FieldSample'){
                const paramsForBuildPath = {
                    dataType: state.mapDataType,
                    radio: state.fsMapCategory,
                    element: state.fsMapFuel? state.fsMapFuel.fuel_type:null,
                    zoom: state.currentZoom,
                    basemap: 'USGSImagery',
                    minElevation: state.elevationFilterValues[0],
                    maxElevation: state.elevationFilterValues[1],
                    windOrMethod: state.fsMapMethod.code_key,
                    windOrSub: state.fsMapSubCat.code_key
                }
                buildPath(paramsForBuildPath, history);
            }
        }
        else{
            setButtonLabel('USGS Imagery');
            map.basemap ="topo";
            const topology = {id: 'topo'}
            setBaseMap(topology);
            if(state.mapDataType==='Weather' || state.mapDataType==='FireDanger'){
                const paramsForBuildPath = {
                    dataType: state.mapDataType,
                    radio: state.selectedRadio.type,
                    element: state.selectedElement?.value,
                    zoom: state.currentZoom,
                    basemap: 'topo',
                    minElevation: state.elevationFilterValues[0],
                    maxElevation: state.elevationFilterValues[1],
                    windOrMethod: state.mapDataType==='FireDanger'? state.nfdrFuelModel:state.wind_direction,
                    windOrSub: state.mapDataType==='FireDanger'? false:state.wind_speed
                }
                buildPath(paramsForBuildPath, history);
            }
            if(state.mapDataType ==='FieldSample'){
                const paramsForBuildPath = {
                    dataType: state.mapDataType,
                    radio: state.fsMapCategory,
                    element: state.fsMapFuel? state.fsMapFuel.fuel_type:null,
                    zoom: state.currentZoom,
                    basemap: 'topo',
                    minElevation: state.elevationFilterValues[0],
                    maxElevation: state.elevationFilterValues[1],
                    windOrMethod: state.fsMapMethod.code_key,
                    windOrSub: state.fsMapSubCat.code_key
                }
                buildPath(paramsForBuildPath, history);
            }
        }
    },[ map, setButtonLabel, setBaseMap, state.selectedRadio, history, state.currentZoom, state.selectedElement, state.elevationFilterValues,
        state.wind_direction, state.wind_speed, state.mapDataType, state.fsMapCategory,
        state.fsMapFuel, state.fsMapMethod.code_key, state.fsMapSubCat.code_key,
        state.nfdrFuelModel
    ]);

    useEffect(()=>{
        if(mapView.current){
            ReactDOM.render(
            <Button variant="outlined" onClick={toggleBaseMap} className="baseMapButton">
                {buttonLabel}
            </Button>,
             mapView.current);
            view.ui.add(mapView.current, "bottom-right");
        }
    },[view.ui,toggleBaseMap, buttonLabel]);
    return <div ref={mapView}/>
}



export default BaseMapToggleButton;